import './styles/toggle.css';

export default function Toggle({ checked, onChange, label, description }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            className={`toggle${checked ? ' toggle--on' : ''}`}
            onClick={() => onChange(!checked)}
        >
            <span className="toggle__text">
                <span className="toggle__label">{label}</span>
                {description && <span className="toggle__description">{description}</span>}
            </span>
            <span className="toggle__track" aria-hidden="true">
                <span className="toggle__thumb" />
            </span>
        </button>
    );
}
